import React from "react";
import assets from "../assets/images";
import "../css/Footer.css";
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate(); // Initialize useNavigate
  const handleButtonClick = () => {
    navigate('/services'); // Navigate to the About Us page when the button is clicked
  };

  return (
    <div className="footer">
      <div className="footer-container">
        <div className="footer-row">
          <div className="footer-col logo-section">
            <img className="logo-foot" src={assets.logo_white} alt="Logo" />
            <p className="para-left">
              Capturing moments, creating memories. We specialize in professional photography for weddings, events, and more. Let us bring your vision to life.
            </p>
            <div className="social-media">
              <a rel="noreferrer" target="_blank" href="https://web.facebook.com/fineportray/">
                <img className="social-icons" src={assets.facebook} alt="Facebook" />
              </a>
              <a rel="noreferrer" target="_blank" href="https://web.facebook.com/fineportray/">
                <img className="social-icons" src={assets.instagram} alt="Instagram" />
              </a>
              <a rel="noreferrer" target="_blank" href="https://web.facebook.com/fineportray/">
                <img className="social-icons" src={assets.youtube} alt="YouTube" />
              </a>
              <a rel="noreferrer" target="_blank" href="https://web.facebook.com/fineportray/">
                <img className="social-icons" src={assets.tiktok} alt="Tiktok" />
              </a>
            </div>
          </div>

          <div className="footer-col services-section">
            <h3>Our Coverage</h3>
            <ul className="coverage-list">
              <li>Wedding Shoots</li>
              <li>Event Shoots</li>
              <li>Concert Shoots</li>
              <li>Portraits Shoots</li>
            </ul>
          </div>

          <div className="footer-col contact-section">
            <h3>Contact Us</h3>
            <div className="contact-info">
              <a rel="noreferrer" target="_blank" href="https://maps.app.goo.gl/PyC231KTZJMYE8RCA" className="a-social">
                <img className="social-icons-x" src={assets.location_pin} alt="Location" />
              </a>
              <a className="a-tag" rel="noreferrer" target="_blank" href="https://maps.app.goo.gl/PyC231KTZJMYE8RCA">96 Moratuwa Road, Piliyandala, Sri Lanka</a>
            </div>

            <div className="contact-info">
              <a href="tel:0113034889" className="a-social">
                <img className="social-icons-x" src={assets.telephone} alt="Phone" />
              </a>
              <div>
              <a className="a-tag" href="tel:0714313131">0714 31 31 31</a>&nbsp;/&nbsp;
              <a className="a-tag" href="tel:0771119696">077 111 96 96</a>&nbsp;/&nbsp;
              <a className="a-tag" href="tel:0113175111">0113 175 111</a>
                
              </div>
            </div>

            <div className="contact-info">
              <a href="mailto:" className="a-social">
                <img className="social-icons-x" src={assets.email} alt="Email" />
              </a>
              <div>
                <a className="a-tag" href="mailto:info@priyanthabandara.lk">info@priyanthabandara.lk</a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <hr className="hr-line" />
          <p className="text-sm text-center foot-copyright">
            Copyright 2025 @<a className="a-tag" rel="noreferrer" target="_blank" href="https://www.blaresinnovations.com/">Blares Innovations</a> - All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
